<template>
  <div class="fixed inset-0 flex items-center justify-center w-full h-full">
    <div class="bg-moss-100 absolute inset-0 w-full h-full" />
    <div class="relative flex flex-col items-center">
      <img
        src="/img/icons/svg/logo-navbar-green.svg"
        alt="Carbonii"
        class="animate-pulse w-40 mb-6"
      >
      <i class="mdi mdi-loading animate-spin text-moss-400 relative text-2xl" />
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
